import CookieHelper from '@/helpers/cookie/index'

const cookieBridge = new CookieHelper()

function isLogged() {
    return !(
        (cookieBridge.getCookie('access_token') === undefined || cookieBridge.getCookie('access_token') === 'undefined')
    )
}

export default isLogged
